module.exports = __webpack_public_path__ + "static/media/gp.a2740b82.svg";